<style lang="scss" scoped>
.logincontainer {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  //border:1px solid red;
  background: $c-blue;

  .legal {
    bottom: 5px;
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    gap: 15px;
    color: white;
    z-index: 999;
  }

  .logocontainer {
    //border:1px solid red;
    display: inline-block;
    position: absolute;
    left: 50px;
    top: 50px;
    @media (max-width: 992px) {
      position: relative;
    }
    .logo {
      width: 250px;
      @media (max-width: 568px) {
        display: block;
        margin: 0 auto;
        //border:1px solid red;
      }
    }
  }
}

:deep(input) {
  border-bottom: none !important;
  color: #fff !important;
}

:deep(label) {
  color: #fff !important;
}

.targetcircles {
  right: 0;
  top: 0;
  z-index: 0;

  //transform: translateY(-50%);
  position: absolute;
  height: 100vh;
  width: 100vh;
  //border: 1px solid red;
  transform: translateX(35%);

  .circle {
    border: 40px solid $c-blue-80;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-name: slidein;
    animation-duration: 2s;
    animation-iteration-count: 1;
  }

  .circle1 {
    height: 95%;
    width: 95%;
    @media (max-width: 1024px) {
      height: 90%;
      width: 90%;
      left: 60%;
    }
  }
  .circle2 {
    height: 80%;
    width: 80%;
  }
  .circle3 {
    height: 70%;
    width: 70%;
  }
}

#loginpage {
  position: relative;
  height: 100vh;

  .login-box-inner {
    display: block;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    @media (max-width: 1024px) {
      top: 40%;
    }
    @media (max-width: 568px) {
      top: 0%;
      //border:1px solid red;
      top: 0;
      transform: translateY(0%);
      padding: 100px 50px 0 50px;
    }
    .login-box-left {
      h1 {
        color: #fff;
        font-weight: 700;
        font-size: 300%;
        margin-bottom: 50px;
        letter-spacing: 2px;
      }

      .border-line {
        width: 100%;
        height: 2px;
        background: $c-white;
      }
      .form-element {
        //border:1px solid red;
        margin-top: 0;
        margin: 15px 0;

        ::placeholder {
          color: $c-white;
          font-weight: 700;
          letter-spacing: 1px;
        }
      }
      .text-right {
        text-align: right;
      }
      button {
        display: inline-block !important;
        margin-top: 30px;
        width: auto;
        font-weight: 700;
        color: $c-white;
        border: 0;
        letter-spacing: 1px;
        position: relative;

        //border:1px solid red;
        padding-right: 60px;
        letter-spacing: 2px;

        span {
          //border:1px solid red;
          display: inline-block;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          background: $c-salmon;
          transition: all 200ms ease;
          svg {
            fill: #fff;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        &:hover {
          span {
            background: $c-salmon-60;
          }
        }
      }
    }

    .logintext {
      text-align: center;
      z-index: 1;
      animation-name: slidein2;
      animation-duration: 2s;
      animation-iteration-count: 1;
      text-align: right;
      position: absolute;
      top: 50%;
      margin-top: -71px;
      right: 7%;
      width: 50%;
      @media (max-width: 1024px) {
        position: relative;
        top: 0;
        margin-top: 0;
        right: 0;
        text-align: left;
        padding-left: 8.5%;
        width: 100%;
      }
      @media (max-width: 992px) {
        width: 100%;
        padding-left: 0%;
      }
      @media (max-width: 568px) {
        text-align: center;
      }
      h1 {
        color: $c-dark-grey !important;
        font-size: 100px !important;
        letter-spacing: 6px !important;
        @media (max-width: 1400px) {
          font-size: 80px !important;
        }
        @media (max-width: 1200px) {
          font-size: 60px !important;
        }
      }

      h2 {
        //font-size: 5vw !important;
        font-size: 24px !important;
        @media (max-width: 1200px) {
          font-size: 18px !important;
        }
      }
    }
  }
}

@keyframes slidein {
  from {
    opacity: 0.5;
    transform: translate(50%, -50%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes slidein2 {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>

<template>
  <div class="logincontainer">
    <div class="legal">
      <ModalButton link="impress">Impressum</ModalButton>
      <ModalButton link="privacy">Datenschutzerklärung</ModalButton>
    </div>
    <div class="targetcircles">
      <div class="circle1 circle">
        <div class="circle2 circle">
          <div class="circle3 circle"></div>
        </div>
      </div>
    </div>
    <div class="logocontainer">
      <img class="logo" src="@/assets/cope-logo.svg" />
    </div>
    <div class="container" id="loginpage">
      <div class="login-box-inner">
        <!--- ACTIVE DIRECTORY FORM-->
        <div class="login-box-left">
          <div class="row">
            <div class="col-lg-6">
              <!---->
              <div class="row">
                <div class="col-12">
                  <h1>Skill Base</h1>
                </div>
              </div>
              <div class="border-line"></div>

              <div class="row">
                <div class="col-12 text-right"><slot /></div>
              </div>
              <!---->
            </div>
          </div>
        </div>
        <!--- ACTIVE DIRECTORY FORM-->
        <div class="logintext splash"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ModalButton from './util/ModalButton.vue';

export default defineComponent({ components: { ModalButton } });
</script>
